import React, { useState,useEffect } from 'react';
import { useHistory } from 'react-router';
import k_title from './img/k_title.jpg';
import k1 from './img/k1.jpg';
import k1_1 from './img/k1_1.jpg';
import k2 from './img/k2.jpg';
import k2_1 from './img/k2_1.jpg';
import k3 from './img/k3.jpg';
import k3_1 from './img/k3_1.jpg';
import k4 from './img/k4.jpg';
import k4_1 from './img/k4_1.jpg';
import queryString from 'query-string';

import ksolution1 from './img/ksolution1.png';
import ksolution2 from './img/ksolution2.png';
import ksolution3 from './img/ksolution3.png';
import ksolution4 from './img/ksolution4.png';

function Klist(props){
    console.log('props : ', props)
    const history = useHistory();
    const [type, setType] = useState('');
    

    const [data, setData] = useState([
        {
            cate:'k',
            type:'유리막코팅',
            product	: '에슐론 NEO-G',
            s_price : 800000,
            d_price : 250000,
            img: ksolution1
        },
        {
            cate:'k',
            type:'가죽코팅',
            product	: '에슐론 Leather',
            s_price : 270000,
            d_price : 200000,
            img: ksolution2
        },
        {
            cate:'k',
            type:'실내클리닝',
            product	: '실내클리닝',
            s_price : 250000,
            d_price : 120000,
            img: ksolution3
        },
        {
            cate:'k',
            type:'광택',
            product	: '광택',
            s_price : 350000,
            d_price : 200000,
            img: ksolution4
        },
    ]);


    const [bgUrl , setbgUrl] = useState([
        {
            type:'유리막코팅',
            src1:k1,
            src2:k1_1
        },
        {
            type:'가죽코팅',
            src1:k2,
            src2:k2_1
        },
        {
            type:'실내클리닝',
            src1:k3,
            src2:k3_1
        },
        {
            type:'광택',
            src1:k4,
            src2:k4_1
        },
    ])

    useEffect(()=> {
  
        setType(queryString.parse(history.location.search).type)
        props.setBannerType('')

    },[bgUrl])

    const onClick = () => {
        if(!window.sessionStorage.result){
            alert('로그인 후 이용이 가능합니다.');
            history.push('/login');
        }else{
            const filterData = data.filter(v => v.type === type)
            console.log('filterData : ', filterData[0])
            history.push('/cart?data='+JSON.stringify(filterData))
        }
    }
    return (
        <>
        <div className="text-center container py-5">
            <img className="w-100" src={k_title} style={{maxWidth:"700px"}}/>
        </div>
        <div className="text-center" style={{backgroundColor:'#EFEFEF'}}>
            {
                bgUrl.map((v,i) => v.type === type && <img key={i} className="w-100" src={v.src1} style={{maxWidth:"850px"}} onClick={onClick}/>)
            }
        </div>
        <div className="container text-center">
            {
                bgUrl.map((v,i) => v.type === type && <img key={i} className="w-100" src={v.src2} style={{maxWidth:"900px"}}/>)
            }
        </div>
        </>
    )
}

export default Klist;